import Vue from 'vue'
import moment from 'moment'

Vue.filter('dateFormat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    if (dataStr==undefined||dataStr == null || dataStr == '') {
        return ''
    }
    const reg = /^\d{10}$/;
    if (reg.test(dataStr)) {
        dataStr=Number(dataStr+'000')
    }
    return moment(dataStr).format(pattern)
});

Vue.filter('timeDiffer', function([startDate,endDate]) {
    if(startDate==undefined||endDate==undefined||startDate==null||startDate==''||endDate==null||endDate==''){
        return ''
    }
    var time=Number(endDate.substr(0,10))-Number(startDate.substr(0,10));
    if (time < 60) {
        return time < 10 ? '00:0' + time : '00:' + time
    } else if (time < 60 * 60) {
        var du = moment.duration(time, 'seconds')
        return (
            (du.minutes() < 10 ? '0' + du.minutes() : du.minutes()) +
            ':' +
            (du.seconds() < 10 ? '0' + du.seconds() : du.seconds())
        )
    } else if (time < 60 * 60 * 24) {
        var du = moment.duration(time, 'seconds')
        return (
            (du.hours() < 10 ? '0' + du.hours() : du.hours()) +
            ':' +
            (du.minutes() < 10 ? '0' + du.minutes() : du.minutes()) +
            ':' +
            (du.seconds() < 10 ? '0' + du.seconds() : du.seconds())
        )
    } else {
        var du = moment.duration(time, 'seconds')
        return (
            du.days() +
            '天' +
            (du.hours() < 10 ? '0' + du.hours() : du.hours()) +
            ':' +
            (du.minutes() < 10 ? '0' + du.minutes() : du.minutes()) +
            ':' +
            (du.seconds() < 10 ? '0' + du.seconds() : du.seconds())
        )
    }
});

Vue.filter('timeFormat', function(timeLong) {
    if(timeLong==undefined||timeLong==null||timeLong==''||timeLong===0){
        return ''
    }
    var time=parseInt(timeLong)
    if (time < 60) {
        return time < 10 ? '00:0' + time : '00:' + time
    } else if (time < 60 * 60) {
        var du = moment.duration(time, 'seconds')
        return (
            (du.minutes() < 10 ? '0' + du.minutes() : du.minutes()) +
            ':' +
            (du.seconds() < 10 ? '0' + du.seconds() : du.seconds())
        )
    } else if (time < 60 * 60 * 24) {
        var du = moment.duration(time, 'seconds')
        return (
            (du.hours() < 10 ? '0' + du.hours() : du.hours()) +
            ':' +
            (du.minutes() < 10 ? '0' + du.minutes() : du.minutes()) +
            ':' +
            (du.seconds() < 10 ? '0' + du.seconds() : du.seconds())
        )
    } else {
        var du = moment.duration(time, 'seconds')
        return (
            du.days() +
            '天' +
            (du.hours() < 10 ? '0' + du.hours() : du.hours()) +
            ':' +
            (du.minutes() < 10 ? '0' + du.minutes() : du.minutes()) +
            ':' +
            (du.seconds() < 10 ? '0' + du.seconds() : du.seconds())
        )
    }
});

Vue.filter('timeFormatWord', function([timeLong,type]) {
    if(timeLong==undefined||timeLong==null||timeLong==''||timeLong===0){
        return '0秒'
    }
    var time=parseInt(timeLong)
    if (time < 60) {
        return  time + '秒'
    } else if (time < 60 * 60) {
        var du = moment.duration(time, 'seconds')
        return  du.minutes()  +'分'+du.seconds() + '秒';
    } else if (time < 60 * 60 * 24) {
        var du = moment.duration(time, 'seconds')
        return   du.hours()  +'时'+ du.minutes()  +'分'+du.seconds() + '秒';
    } else {
        var du = moment.duration(time, 'seconds')
        if(type==1){
            return ( (du.days() *24) + du.hours() ) +'时'+ du.minutes()  +'分'+du.seconds() + '秒';
        }else {
            return du.days() +'天'+  du.hours()+'时'+ du.minutes()  +'分'+du.seconds() + '秒';
        }

    }
});

Vue.filter('msTimeFormatWord', function([timeLong,type]) {
    if(timeLong==undefined||timeLong==null||timeLong==''||timeLong===0){
        return '0秒'
    }
    if(timeLong!==0){
        timeLong=Math.ceil(timeLong/1000);
    }

    var time=parseInt(timeLong)
    if (time < 60) {
        return  time + '秒'
    } else if (time < 60 * 60) {
        var du = moment.duration(time, 'seconds')
        return  du.minutes()  +'分'+du.seconds() + '秒';
    } else if (time < 60 * 60 * 24) {
        var du = moment.duration(time, 'seconds')
        return   du.hours()  +'时'+ du.minutes()  +'分'+du.seconds() + '秒';
    } else {
        var du = moment.duration(time, 'seconds')
        if(type==1){
            return ( (du.days() *24) + du.hours() ) +'时'+ du.minutes()  +'分'+du.seconds() + '秒';
        }else {
            return du.days() +'天'+  du.hours()+'时'+ du.minutes()  +'分'+du.seconds() + '秒';
        }

    }
});

Vue.filter('numberFormat', function(number) {
    if(number==undefined||number==null||number==''){
        return 0
    }else {
        return number
    }
});

Vue.filter('percentFormat', function([a,total,base,num]) {
    if(a==undefined||a==null||a==''){
        return 0
    }
    if(total==undefined||total==null||total==''){
        return 0
    }
    return ((a/total)*base).toFixed(num)
});
Vue.filter('subtractionFormat', function([max,min]) {
    if(max==undefined||max==null||max==''){
        return 0
    }
    if(min==undefined||min==null||min==''){
        return 0
    }
    return max-min
});
Vue.filter('subPercentFormat', function([a,total,base,num]) {
    if(a==undefined||a==null||a==''){
        return 0
    }
    if(total==undefined||total==null||total==''){
        return 0
    }
    return (((total-a)/total)*base).toFixed(num)
});

Vue.directive("btn-control", {
    // 插入dom 时做的事情
    inserted: function(el, bind) {
        el.addEventListener("click", () => {
            el.classList.add('is-disabled');
            el.disabled = true;
            setTimeout(() => {
                el.disabled = false;
                el.classList.remove('is-disabled');
            }, bind.value)
        });
    }
});